import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/apiClient";
import { CERTS } from "@/constants/testIds";
import { Award } from "lucide-react";
import { CertificateShare, CertificateQR, VerifiedBadge } from "@/components/CertificateShare";

export default function CertificatesPage() {
  const [certs, setCerts] = useState([]);

  useEffect(() => { api.get("/certificates").then((r) => setCerts(r.data)); }, []);

  return (
    <div data-testid={CERTS.root} className="space-y-8 animate-fade-up">
      <div>
        <div className="label-mono text-primary">// certificates</div>
        <h1 className="mt-2 font-display text-3xl font-black tracking-tighter sm:text-4xl">Your achievements.</h1>
        <p className="mt-1 text-sm text-muted-foreground">Every certificate has a QR code and a public verification page — share proudly.</p>
      </div>

      {certs.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-8 text-center">
          <Award className="mx-auto h-8 w-8 text-muted-foreground" />
          <div className="mt-2 text-sm text-muted-foreground">No certificates yet. Complete a path to earn one.</div>
          <Link to="/app/paths" className="mt-3 inline-block text-xs font-mono text-primary hover:underline">Browse paths →</Link>
        </div>
      ) : (
        <div className="grid gap-6 lg:grid-cols-2">
          {certs.map((c) => (
            <div
              key={c.cert_id}
              data-testid={CERTS.card(c.cert_id)}
              className="relative overflow-hidden rounded-2xl border border-border bg-gradient-to-br from-primary/10 to-accent/5 p-6 md:p-8"
            >
              <div className="grid-pattern grid-pattern-fade absolute inset-0 opacity-30" />
              <div className="relative">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <VerifiedBadge />
                    <div className="mt-4 label-mono text-primary">// certificate of completion</div>
                    <div className="mt-3 text-xs text-muted-foreground">Awarded to</div>
                    <div className="font-display text-2xl font-black tracking-tighter">{c.user_name}</div>
                    <div className="mt-3 text-xs text-muted-foreground">for successfully completing</div>
                    <div className="font-display text-xl font-bold">{c.path_title}</div>
                  </div>
                  <CertificateQR cert={c} size={88} />
                </div>

                <div className="mt-6 flex items-end justify-between">
                  <div>
                    <div className="label-mono">Cert ID</div>
                    <div className="font-mono text-sm">{c.cert_id}</div>
                  </div>
                  <div className="text-right">
                    <div className="label-mono">Issued</div>
                    <div className="font-mono text-sm">{new Date(c.issued_at).toLocaleDateString()}</div>
                  </div>
                </div>

                <div className="mt-6 border-t border-border pt-5">
                  <div className="label-mono mb-3">Share your achievement</div>
                  <CertificateShare cert={c} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
